import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { SettingsPage } from 'pages/settings-page/settings-page';

@NgModule({
    declarations: [SettingsPage],
    imports: [PagesModule, ComponentsModule]
})
export class SettingsPageModule {}